module.exports = __webpack_public_path__ + "img/pro3.f6f25632.jpg";